//

export default function WebbDividerSmall() {

  return (
  <>
    <div className="pb-1"></div>
  </>
  )
}